import { useObjectKeyPress } from './useObjectKeyPress';

interface ArrowListenerProps {
  arrowLeft: boolean;
  arrowUp: boolean;
  arrowRight: boolean;
  arrowDown: boolean;
}

export const useArrowListener = (): ArrowListenerProps => {
  const { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } = useObjectKeyPress(
    'ArrowLeft',
    'ArrowUp',
    'ArrowRight',
    'ArrowDown'
  );

  return {
    arrowLeft: ArrowLeft,
    arrowUp: ArrowUp,
    arrowRight: ArrowRight,
    arrowDown: ArrowDown,
  };
};
